/* global window */
/**
 * here be dragons, hacky hacky dragons
 * Just make sure it doesnt break any real functionality even when it fails.
 */
import store from '../store';

const GTM_OFF = process.env.REACT_APP_ENV !== 'PROD';
const DEBUG_GTM = true;

/**  create && || push message object to windows dataLayer array
 *
 * @param { Object } message message to add to data layer
 *
 * @returns { undefined }
 */
export function pushMessage(message) {
  if (GTM_OFF) return;
  if (DEBUG_GTM) logMessageToConsole(message);
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(message);
  } catch (e) {
    console.error(`caught GTM ERROR - ${e}`);
  }
}


export function gtmSimplePageLoadEvent(page, data = {}) {
  if (GTM_OFF) return;
  pushMessage({
    event: 'page_load',
    page_name: page,
    ...data
  });
}


export function gtmCardLoadEvent(card, data = {}) {
  if (GTM_OFF) return;
  pushMessage({
    event: 'card_load',
    card_name: card,
    ...data
  });
}


const MAX_ATTEMPTS = 5;
const ATTEMPT_DELAY_MS = 2000;
export function gtmPageLoadEvent(page, attempts = 0) {
  if (GTM_OFF) return;
  try {
    const data = pageLoadData(page);
    // not gaurenteed info will be availible. try again later.
    if (!data && attempts + 1 < MAX_ATTEMPTS) {
      window.setTimeout(gtmPageLoadEvent.bind(null, page, attempts + 1), ATTEMPT_DELAY_MS);
      return;
    }

    pushMessage({
      event: 'page_load',
      page_name: page,
      ...data
    });
  } catch (e) {
    console.error(`caught GTM ERROR - ${e}`);
  }
}


export function gtmCardEvent(category, action, label = '', callback = () => { }) {
  return () => {
    if (GTM_OFF) return callback();
    pushMessage({
      event: 'card_interaction',
      event_category: category,
      event_action: action,
      event_label: label
    });
    return callback();
  };
}


export function gtmPayment(orderData, transaction) {
  if (GTM_OFF) return;
  try {
    pushMessage({
      event: 'purchase',
      ecommerce: {
        purchase: {
          actionField: {
            id: transaction.vendorTxCode,
            affiliation: 'mysofology',
            revenue: transaction.amount.saleAmount,
            tax: '',
            shipping: ''
          },
          products: productsFromItems(orderData.OrderDetails.Items)
        }
      }
    }
    );
  } catch (e) {
    console.error(`caught GTM ERROR - ${e}`);
  }
}


const PAGE_REQS = {
  '/': ['user_id', 'basket_contents', 'recently_viewed', 'favourites', 'orders', 'deliveries'],
  '/basket': ['user_id', 'basket_contents'],
  '/orders': ['user_id', 'orders'],
  '/account': ['user_id']
};
function pageLoadData(page, attempts = 0) {
  const state = store.getState();
  const { userGuid } = state.user;
  const { favourites, recent } = state.activity;
  const { events } = state.eventFeed;
  const { baskets } = state.baskets;

  let dataFromEvents;
  const GETTERS = {
    user_id: () => PAGE_REQS[page].includes('user_id') ? userGuid : false,
    basket_contents: () => PAGE_REQS[page].includes('basket_contents') && baskets && baskets[0] ? productsFromBasketItems(baskets[0]) : false,
    recently_viewed: () => PAGE_REQS[page].includes('recently_viewed') ? mapActivityItems(recent) : false,
    favourites: () => PAGE_REQS[page].includes('favourites') ? mapActivityItems(favourites) : false,
    orders: () => {
      if (!PAGE_REQS[page].includes('orders')) return false;
      if (!dataFromEvents) dataFromEvents = getDataFromEvents(events);
      return dataFromEvents.orders;
    },
    deliveries: () => {
      if (!PAGE_REQS[page].includes('deliveries')) return false;
      if (!dataFromEvents) dataFromEvents = getDataFromEvents(events);
      return dataFromEvents.deliveries;
    }
  };

  const data = {
    user_id: GETTERS.user_id(),
    basket_contents: GETTERS.basket_contents(),
    recently_viewed: GETTERS.recently_viewed(),
    favourites: GETTERS.favourites(),
    orders: GETTERS.orders(),
    deliveries: GETTERS.deliveries()
  };

  Object.keys(data).forEach((key) => { if (!data[key]) delete data[key]; });
  // ensure required data is there else fail
  const remainingKeys = Object.keys(data);
  if (PAGE_REQS[page].every(req => remainingKeys.includes(req)) || attempts > MAX_ATTEMPTS) return data;
  return false;
}


// this is horrendous :(
const CARDS_TO_TRACK = ['OrderSummary', 'ConfirmOrder', 'DeliveryFlow', 'BookDelivery', 'DeliveryBooked'];
function getDataFromEvents(events) {
  if (!events) return false;
  const orders = [];
  const deliveries = [];

  const ordersData = events.reduce((data, event) => {
    const newData = { ...data };
    if (CARDS_TO_TRACK.includes(event.cardName)) {
      if (!newData[event.payload.orderIdx]) newData[event.payload.orderIdx] = {};
      newData[event.payload.orderIdx][event.cardName] = event;
    }
    return newData;
  }, {});

  Object.keys(ordersData).forEach((orderIdx) => {
    const order = ordersData[orderIdx];
    orders.push({
      order_number: `${order.OrderSummary.payload.orderRef}/${order.OrderSummary.payload.orderNo}`,
      order_confirmed: !order.ConfirmOrder,
      order_contents: productsFromItems(order.OrderSummary.payload.items)
    });
    if (order.DeliveryFlow) {
      let delivery = {
        order_number: `${order.OrderSummary.payload.orderRef}/${order.OrderSummary.payload.orderNo}`,
        truck_size: order.OrderSummary.payload.items.find(x => x.catNo === '486-67117') ? 'small' : 'default',
        sofashield_upsell: !!order.OrderSummary.payload.items.find(x => ['359-10006', '359-10007', '359-10025', '359-10026', ''].includes(x.catNo)),
        delivery_booked: !!order.DeliveryBooked,
        order_balance: order.OrderSummary.payload.balance,
        order_deposit: order.OrderSummary.payload.deposit,
        order_total: order.OrderSummary.payload.total
      };
      if (delivery.delivery_booked) {
        delivery = {
          ...delivery,
          delivery_date: order.DeliveryBooked.payload.deliveryDate
        };
      }
      deliveries.push({ delivery });
    }
  });
  return { orders, deliveries };
}


function mapActivityItems(items) {
  if (!items) return false;
  return items.map(item => ({
    product_name: `${item.rangeNameForUrl} ${item.webDescription}`,
    product_range: item.rangeNameForUrl,
    product_price: item.currentPrice
  }));
}


function productsFromBasketItems(basket) {
  if (!basket.entries) return [];
  return basket.entries.map(item => ({
    product_name: `${item.range || ''} ${item.bcop || item.product.name || ''}`,
    product_range: item.range || 'SOFOLOGY',
    product_price: item.totalPrice.value,
    quantity: item.quantity || 1
  }));
}


function productsFromItems(items) {
  return items.map((item) => {
    let str = item.detail || '';
    let range = item.product.toUpperCase().trim();
    if (!range || range === '') {
      range = str.split(' ')[0];
    }
    range = `${(range[0] || '').toUpperCase()}${(range.slice(1) || '').toLowerCase()}`;
    str = str.replace(new RegExp(range, 'g'), '');
    str = str.split(' in ');
    // const bcop = str[0] ? str[0].trim() : '';
    const swatch = str[1] && `in ${str[1]}`.trim();
    return {
      name: item.detail,
      itemType: item.itemType || '',
      id: item.catNo,
      price: item.value,
      brand: range || 'SOFOLOGY',
      category: 'Sofas',
      variant: swatch,
      quantity: item.qty || 1
    };
  });
}


function logMessageToConsole(message) {
  console.log(`%c ${JSON.stringify(message, null, 2)}`,
    'border-left: 4px solid red; padding-left: 5px; padding-top: 10px; background: rgba(255, 5, 5, 0.05);',
    message);
}



// WEBPACK FOOTER //
// ./src/services/gtmService.js